import React, {useEffect, useState, useContext, useRef} from 'react';
import _ from "lodash";

import ReactiveJob from "../app/interfaces/reactiveJob";
import PlannedJob from "../app/interfaces/plannedJob";
import Asset from "../app/interfaces/asset";
import plannedJob from "../app/interfaces/plannedJob";

const displayLimit = {
  asset: 20,
  planned: 20,
  reactive: 20,
  schedule: 25,
};

const useInfiniteScroll = (initialList: ReactiveJob[] | PlannedJob[] | Asset[], type: string) => {
  const fullList = useRef(initialList);
  const [ renderedData, setRenderedData ] = useState<any[]>([]);
  const [ dataIndex, setDataIndex ] = useState(-1);

  useEffect(() => {
    if(dataIndex < 1) return;

    if(fullList.current.length > 0 && dataIndex < fullList.current.length) {
      let index = dataIndex;
      let newRenderedData: any[] = _.cloneDeep(renderedData);
      let toAdd: ReactiveJob[] | PlannedJob[] | Asset[] = fullList.current.slice(index, index + displayLimit[type]);

      newRenderedData = newRenderedData.concat(toAdd);

      setRenderedData(_.uniqWith(newRenderedData,(a,b) => {

        if(type == 'reactive') {
          return a.CallNo == b.CallNo;
        } else if (type == 'planned') {
          return a.PMCallNo == b.PMCallNo;
        } else if(type == 'asset') {
          return a.SerialNo == b.SerialNo;
        }

      }));
    }

  },[dataIndex]);

  const updateRenderedData = (newData: []) => {
    fullList.current = newData;
    setRenderedData(newData.slice(0, displayLimit[type]));
    setDataIndex(0);
  };

  const handleBottom = () => {
    setDataIndex(prevState => {

      if(prevState < fullList.current.length) return prevState + displayLimit[type];

      return prevState;
    });
  };

  return {
    updateRenderedData,
    handleBottom,
    renderedData,
  }
};

export default useInfiniteScroll;